<template>
<div class="opt-content-wrapper pay-pane active" >

    <p class="mt-2">Enter your card details to pay</p>

    <div class="modal-body">
        <form class="form" ref="cardForm" data-bitwarden-watching="1" v-on:submit.prevent="collectPin">
            <div class="row mx-0">
                <div class="col-12 px-0">
                    <div class="form-group" ref="cardFormGroup">
                        <label for="card_cc">Card Number</label>
                        <the-mask :mask="['#### #### #### #### ###']" v-model="card_cc" id="card_cc" ref="card_cc" class="card_number cc-masked form-control " placeholder="0000 0000 0000 0000 000" title="Enter your card number" data-exception="cc" data-valid-example="5063 5232 3523 2533 234" required autofocus @focus.native="card_cc_hover = true" @blur.native="card_cc_hover = false" :style="{ borderColor: (card_cc_hover ? ccBorderColor : borderColor)  }" />
                        <span class="invalid-feedback" :style="(errors.card_cc) ? 'display : inline' : ''">Invalid card number</span>
                    </div>
                </div>
            </div>

            <div class="row m-0">
                <div class="col-6 px-0">
                    <div class="form-group" ref="expiryFormGroup">
                        <label for="card_exp">Expiry Date</label>
                        <the-mask :mask="['## / ##']" v-model="card_exp" id="card_exp" ref="card_exp" class="form-control" placeholder="MM / YY" required @focus.native="card_exp_hover = true" @blur.native="card_exp_hover = false" :style="{ borderColor: (card_exp_hover ? expBorderColor : borderColor)  }" />
                        <span class="invalid-feedback" :style="(errors.card_exp) ? 'display : inline' : ''">Invalid expiry date</span>
                    </div>
                </div>
                <div class="col-6 px-0">
                    <div class="form-group" ref="cvvFromGroup">
                        <label for="card_cvv">CVV</label>
                        <the-mask :mask="['###']" v-model="card_cvv" id="card_cvv" ref="card_cvv" class="form-control" placeholder="123" required="" title="Enter your card cvv" @focus.native="card_cvv_hover = true" @blur.native="card_cvv_hover = false" :style="{ borderColor : (card_cvv_hover ? cvvBorderColor : borderColor)  }" />
                        <span class="invalid-feedback" :style="(errors.card_cvv) ? 'display : inline' : ''">Invalid card CVV</span>
                    </div>
                </div>
            </div>

            <div class="row m-0">
                <div class="col-12 px-0">
                    <div class="form-group mb-0">
                        <button type="submit" class="btn app-bg-color" :style="{ background : appColor }" ref="btnActionPay" id="btnActionPay" @click.prevent="collectPin">Continue</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import {
    TheMask
} from 'vue-the-mask'

export default {
    name: 'CardPayment',
    props: ['appColor', 'client_info'],
    components: {
        TheMask
    },
    watch: {
        card_cc_hover(newVal) {
            if (newVal)
                this.ccBorderColor = this.appColor;
        },
        card_exp_hover(newVal) {
            if (newVal)
                this.expBorderColor = this.appColor;
        },
        card_cvv_hover(newVal) {
            if (newVal)
                this.cvvBorderColor = this.appColor;
        },
        isVerve(val) {
            this.isVerve = val;
        },
        card_cc(val) {
            var vm = this;
            switch (val.substring(0, 1)) {
                case "0":
                case "1":
                case "2":
                case "6":
                case "7":
                case "8":
                case "9":
                    this.$refs.card_cc.$el.focus();
                    this.errors.card_cc = true;
                    this.$refs.card_cc.$el.className = "card_number cc-masked form-control is-invalid";
                    break;

                default:
                    this.errors.card_cc = false;
                    this.$refs.card_cc.$el.className = "card_number cc-masked form-control";
                    this.setCardType(val)

                    setTimeout(function () {
                        if (val.length > 2) {
                            vm.setCardType(val)
                            if (!vm.isVerve && val.length == 16) {
                                vm.setCardType(val)
                                vm.$store.dispatch('card_cc', vm.card_cc);
                                vm.$refs.card_exp.$el.focus();
                            } else if (vm.isVerve && val.length == 19) {
                                vm.$store.dispatch('card_cc', vm.card_cc);
                                vm.$refs.card_exp.$el.focus();
                            }
                        } else {
                            vm.isVerve = false;
                        }
                    }, 200);
            }
        },
        card_exp(val) {
            var vm = this;
            if (vm.$refs.card_exp.$el.focus()) {
                vm.$refs.card_exp.$el.className += "appColor";
            }

            if (val.length == 4) {
                if (this.validateCardExp()) {
                    this.$store.dispatch('card_exp', this.card_exp);
                    vm.$refs.card_cvv.$el.focus();
                } else {
                    // Push error
                }

            }
        },
        card_cvv(val) {
            var vm = this;
            if (val.length === 3) {
                this.$store.dispatch('card_cvv', this.card_cvv);
            }
        }
    },
    mounted() {
        this.ccBorderColor = this.appColor;
        document.getElementById('card_cc').focus();
    },
    data() {
        return {
            isVerve: false,
            getPin: false,
            card_cc: '',
            card_cc_hover: true,
            card_exp: '',
            card_exp_hover: false,
            card_cvv: '',
            card_cvv_hover: false,
        borderColor: '#e4e4e4',
            ccBorderColor: '',
            expBorderColor: '',
            cvvBorderColor: '',
            errors: {
                card_cc: false,
                card_exp: false,
                card_cvv: false,
            }
        }
    },
    methods: {
        setCardType(val) {
            switch (val.substring(0, 2)) {
                // american express
                case '34':
                case '37':
                    this.$refs.cardFormGroup.className = "form-group amex focus";
                    this.isVerve = false;
                    break;

                    // visa
                case '40':
                case '41':
                case '42':
                case '43':
                case '44':
                case '45':
                case '46':
                case '47':
                case '48':
                case '49':
                    this.$refs.cardFormGroup.className = "form-group visa focus";
                    this.isVerve = false;
                    break;

                    // mastercard
                case '22':
                case '36':
                case '51':
                case '52':
                case '53':
                case '54':
                case '55':
                    this.$refs.cardFormGroup.className = "form-group mastercard focus";
                    this.isVerve = false;
                    break;

                case '50': // verve
                case '65':
                    if (!this.isVerve)
                        this.isVerve = true;
                    this.$refs.cardFormGroup.className = "form-group verve focus";
                    break;

                default:
                    this.$refs.cardFormGroup.className = "form-group focus";
            }
        },
        validateCardExp() {
            var exp = this.card_exp.split(""),
                today, someday,
                exMonth = exp[0] + exp[1],
                exMonth = parseInt(exMonth),
                exYear = "20" + exp[2] + exp[3],
                today = new Date(),
                someday = new Date();
            someday.setFullYear(exYear, parseInt(exMonth), 1);

            if (this.card_exp.length < 4 || someday < today || exMonth > 12) {
                this.errors.card_exp = true;
                this.$refs.card_exp.$el.className = "form-control is-invalid";
                return false;
            } else {
                this.errors.card_exp = false;
                this.$refs.card_exp.$el.className = "form-control";
                return true;
            }
        },
        validateCardCc() {
            if (this.isVerve && this.card_cc.length > 16) {
                return true;
            } else if (!this.isVerve && this.card_cc.length === 16) {
                return true;
            } else {
                this.$refs.card_cc.$el.className = "form-control is-invalid";
                this.errors.card_cc = true;
                return false;
            }
        },
        validateCardCvv() {
            if (this.card_cvv.length < 3)
                return false;
            return true;
        },
        collectPin() {
            if (this.validateCardCvv() && this.validateCardExp() && this.validateCardCc() && this.card_cvv.length === 3) {
                this.$parent.changeComponent('Pin');
            } else {
                if (!this.validateCardCvv()) {
                    this.errors.card_cvv = true;
                    this.$refs.card_cvv.$el.className = "form-control is-invalid";
                } else {
                    this.errors.card_cvv = false;
                    this.$refs.card_cvv.$el.className = "form-control";
                }
                if (!this.validateCardCc()) {
                    this.errors.card_cc = true;
                    this.$refs.card_cc.$el.className = "form-control is-invalid";
                } else {
                    this.errors.card_cc = false;
                    this.$refs.card_cc.$el.className = "form-control";
                }

                if (!this.validateCardExp()) {
                    this.errors.card_exp = true;
                    this.$refs.card_exp.$el.className = "form-control is-invalid";
                } else {
                    this.errors.card_exp = false;
                    this.$refs.card_exp.$el.className = "form-control";
                }

            }
        },
    }
}
</script>
